export default __webpack_public_path__ + "static/logo-42d9aa9c44764c6afea7fffbfab4d0a0.png";